// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"550":"0ea00f48","569":"4115ada0","944":"2082cd44"}[chunkId] + ".chunk.js";
};